import React from "react";

/**
 * Mobile Hero — independent layout for < 1024px.
 * The <section> itself is transparent — the App wrapper carries the background.
 */
export default function HeroMobile() {
  const thumbStyleBase = {
    aspectRatio: "16/9",
    filter: "blur(1.8px)",
    boxShadow: "0 12px 26px rgba(0,0,0,0.55)",
  };

  return (
    <section className="block lg:hidden relative w-full overflow-hidden" style={{ paddingTop: "56px" }}>
      <div className="relative w-full" style={{ aspectRatio: "390/380" }}>
        {/* Container shape */}
        <div
          className="absolute"
          style={{
            left: "2%",
            top: "3%",
            width: "96%",
            height: "62%",
            backgroundImage: "url('/assets/images/shape.png')",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
          }}
        />

        {/* Left column thumbnails */}
        <div
          className="absolute hero-thumb-left"
          style={{ left: "-10%", top: "7%", width: "25%", "--delay-in": "0.9s", "--delay-float": "1.65s", "--float-dur": "5s" }}
        >
          <img
            src="/assets/thumbnails/thumb-mario.jpg"
            alt=""
            aria-hidden="true"
            className="w-full rounded-[12px] object-cover block"
            style={{ ...thumbStyleBase, transform: "rotate(-6deg)" }}
          />
        </div>
        <div
          className="absolute hero-thumb-left"
          style={{ left: "-8%", top: "22%", width: "23%", "--delay-in": "1.02s", "--delay-float": "2.05s", "--float-dur": "5.5s" }}
        >
          <img
            src="/assets/thumbnails/thumb-golf-wheel.jpg"
            alt=""
            aria-hidden="true"
            className="w-full rounded-[12px] object-cover block"
            style={{ ...thumbStyleBase, transform: "rotate(-3deg)" }}
          />
        </div>
        <div
          className="absolute hero-thumb-left"
          style={{ left: "-10%", top: "37%", width: "24%", "--delay-in": "1.14s", "--delay-float": "1.90s", "--float-dur": "4.8s" }}
        >
          <img
            src="/assets/thumbnails/thumb-grocery.jpg"
            alt=""
            aria-hidden="true"
            className="w-full rounded-[12px] object-cover block"
            style={{ ...thumbStyleBase, transform: "rotate(-4deg)" }}
          />
        </div>

        {/* Right column thumbnails */}
        <div
          className="absolute hero-thumb-right"
          style={{ right: "-10%", top: "7%", width: "25%", "--delay-in": "1.0s", "--delay-float": "1.85s", "--float-dur": "5.2s" }}
        >
          <img
            src="/assets/thumbnails/thumb-netflix.jpg"
            alt=""
            aria-hidden="true"
            className="w-full rounded-[12px] object-cover block"
            style={{ ...thumbStyleBase, transform: "rotate(6deg)" }}
          />
        </div>
        <div
          className="absolute hero-thumb-right"
          style={{ right: "-8%", top: "22%", width: "23%", "--delay-in": "1.12s", "--delay-float": "2.15s", "--float-dur": "5.6s" }}
        >
          <img
            src="/assets/thumbnails/thumb-efoil.jpg"
            alt=""
            aria-hidden="true"
            className="w-full rounded-[12px] object-cover block"
            style={{ ...thumbStyleBase, transform: "rotate(3deg)" }}
          />
        </div>
        <div
          className="absolute hero-thumb-right"
          style={{ right: "-10%", top: "37%", width: "24%", "--delay-in": "1.24s", "--delay-float": "1.75s", "--float-dur": "4.6s" }}
        >
          <img
            src="/assets/thumbnails/thumb-gym-shed.jpg"
            alt=""
            aria-hidden="true"
            className="w-full rounded-[12px] object-cover block"
            style={{ ...thumbStyleBase, transform: "rotate(4deg)" }}
          />
        </div>

        {/* Centered headline block */}
        <div
          className="absolute inset-x-0 flex flex-col items-center text-center"
          style={{ top: "12%" }}
        >
          <h1
            className="hero-anim-yt"
            style={{
              fontFamily: "'Clash Display',sans-serif",
              fontWeight: 600,
              fontSize: "clamp(52px, 13.5vw, 170px)",
              lineHeight: 0.95,
              letterSpacing: "-0.02em",
              color: "#FFFFFF",
              margin: 0,
            }}
          >
            YouTube
          </h1>

          <p
            className="hero-anim-sub"
            style={{
              fontFamily: "'Karvest','SF Pro Display',sans-serif",
              fontWeight: 400,
              fontSize: "clamp(14px, 3.9vw, 48px)",
              lineHeight: 1.1,
              color: "#9AA3B7",
              margin: "2.5% 0 2% 0",
            }}
          >
            Packaging Built To
          </p>

          <div className="relative inline-flex items-center hero-anim-cta">
            <h2
              style={{
                fontFamily: "'Clash Display',sans-serif",
                fontWeight: 500,
                fontSize: "clamp(26px, 7vw, 90px)",
                lineHeight: 1,
                letterSpacing: "-0.02em",
                color: "#FFFFFF",
                margin: 0,
              }}
            >
              Earn More Clicks
            </h2>
            <img
              src="/assets/images/click-icon.png"
              alt=""
              aria-hidden="true"
              className="absolute pointer-events-none hero-anim-curs"
              style={{
                right: "-9%",
                bottom: "-55%",
                width: "clamp(22px, 5.8vw, 70px)",
                height: "auto",
              }}
            />
          </div>
        </div>

        {/* Left pill — View Work */}
        <button
          type="button"
          className="absolute inline-flex items-center justify-center gap-2 rounded-full text-white hero-anim-btn"
          style={{
            left: "4%",
            top: "62%",
            transform: "translateY(-50%)",
            padding: "2% 3.8%",
            border: "1px solid rgba(139,92,246,0.32)",
            backgroundColor: "rgba(20,22,47,0.55)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            fontFamily: "'SF Pro Display',sans-serif",
            fontWeight: 400,
            fontSize: "clamp(12px, 2.9vw, 36px)",
            boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(calc(-50% - 2px))";
            e.currentTarget.style.boxShadow = "0 12px 28px rgba(79,70,229,0.35), inset 0 1px 0 rgba(255,255,255,0.10)";
            e.currentTarget.style.backgroundColor = "rgba(30,32,60,0.75)";
            e.currentTarget.style.borderColor = "rgba(139,92,246,0.55)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(-50%)";
            e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.35)";
            e.currentTarget.style.backgroundColor = "rgba(20,22,47,0.55)";
            e.currentTarget.style.borderColor = "rgba(139,92,246,0.32)";
          }}
          onClick={() => {
            const el = document.querySelector("#featured");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
        >
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#8B5CF6"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="7" y1="17" x2="17" y2="7" />
            <polyline points="7 7 17 7 17 17" />
          </svg>
          View Work
        </button>

        {/* Right pill — Book a Project */}
        <a
          href="https://tally.so/r/b5EyVe"
          target="_blank"
          rel="noopener noreferrer"
          className="absolute inline-flex items-center justify-center gap-2 rounded-full text-white hero-anim-btn"
          style={{
            right: "4%",
            top: "62%",
            transform: "translateY(-50%)",
            padding: "2% 3.8%",
            border: "1px solid rgba(139,92,246,0.32)",
            backgroundColor: "rgba(20,22,47,0.55)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            fontFamily: "'SF Pro Display',sans-serif",
            fontWeight: 400,
            fontSize: "clamp(12px, 2.9vw, 36px)",
            boxShadow: "0 6px 18px rgba(0,0,0,0.35)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(calc(-50% - 2px))";
            e.currentTarget.style.boxShadow = "0 12px 28px rgba(79,70,229,0.35), inset 0 1px 0 rgba(255,255,255,0.10)";
            e.currentTarget.style.backgroundColor = "rgba(30,32,60,0.75)";
            e.currentTarget.style.borderColor = "rgba(139,92,246,0.55)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(-50%)";
            e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.35)";
            e.currentTarget.style.backgroundColor = "rgba(20,22,47,0.55)";
            e.currentTarget.style.borderColor = "rgba(139,92,246,0.32)";
          }}
        >
          <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#8B5CF6"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <line x1="7" y1="17" x2="17" y2="7" />
            <polyline points="7 7 17 7 17 17" />
          </svg>
          Book a Project
        </a>

        {/* Center circular badge */}
        <div
          className="absolute flex items-center justify-center rounded-full hero-anim-logo"
          style={{
            top: "62%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "17%",
            aspectRatio: "1/1",
            background: "linear-gradient(135deg, #4F46E5 0%, #8B5CF6 100%)",
            boxShadow: "0 16px 50px rgba(79,70,229,0.55)",
          }}
        >
          <img
            src="/assets/brand/clickory-mark.png"
            alt="Clickory"
            data-testid="hero-logo-mark-mobile"
            style={{ width: "54%", height: "auto" }}
          />
        </div>
      </div>
    </section>
  );
}
